// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1bZDG","buttons":"styles_buttons__3J_q2"};